'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/daysFromNow.js
// module id = 160
// module chunks = 0